import { requestGet } from '@/common/request';

interface ResultData {
  data: number;
}

/**
 * 消息中心-所有未读消息数量
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1121439607
 */
export default function genericMessageTotalMessageNum(): Promise<RequestResult<ResultData>> {
  return requestGet('/generic/platMktMsgBk/message/totalMessageNum');
}
